<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 14:48:25
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-02 14:57:45
-->
<template>
	<!-- 确认合作约定组件 -->
	<div class="ConfirmAppoint">
		<div>
			<h5 class="font-h3-medium">确认合作约定</h5>
			<p class="mt-8 flex-row-align-center">
				<i class="el-icon-info yx-color-text-secondary mr-4 fz-12"></i>
				<span class="font-h6-regular yx-color-text-regular">协议项将对所有合作商品共同生效，若需要对各商品设置不同协议项，请分开申样。</span>
			</p>
			<!-- 选择带货方式 -->
			<div class="mt-28 flex-row-align-center">
				<span class="font-h4-regular yx-color-text-regular redStar mr-32">带货方式</span>
				<div v-for="item in commerceList" :key="item.value" class="flex-row-align-center flex-just-start mr-24 sellRadio">
					<el-radio v-model="params.sellGoodsType" :label="item.value">
						{{ item.label }}
					</el-radio>
					<Explain
						content="合作达人带货内容以实际交付为准，不限制直播/视频形式"
						placement="top"
						class="explain"
						classStyle="yx-color-text-secondary"
					></Explain>
				</div>
			</div>
			<!-- 备注部分 -->
			<div class="mt-28 flex-just-start flex-row-align-center">
				<span class="remark font-h4-regular yx-color-text-regular">申样备注</span>
				<el-input
					type="textarea"
					:rows="2"
					placeholder="请填写补充约定或其他合作信息"
					show-word-limit
					v-model="params.buyerRemark"
					maxlength="200"
				></el-input>
			</div>
		</div>
	</div>
</template>
<script>
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	name: 'ConfirmAppoint',
	data() {
		return {
			params: {
				sellGoodsType: 0,
				buyerRemark: '',
			},
			// 数据字典
			commerceList: [
				{
					label: '直播',
					value: 1,
				},
				{
					label: '短视频',
					value: 2,
				},
				{
					label: '不限',
					value: 0,
				},
			],
		};
	},
	props: {
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
	},
	components: {
		Explain: () => import('@/components/common/explain'),
	},
	watch: {
		'params.sellGoodsType'() {
			this.change();
		},
		'params.buyerRemark'() {
			this.change();
		},
	},
	created() {
		this.change();
	},
	methods: {
		//当值发生改变，触发该方法，并且向外部传出改变的值
		change() {
			this.$emit('change', this.params);
		},
		//重置所有的值
		reset() {
			//清空默认值
			this.params = {
				sellGoodsType: 0,
				buyerRemark: '',
			};
		},
	},
};
</script>
<style lang="less" scoped>
.explain {
	position: relative;
	right: 28px;
	bottom: 1px;
}
.sellRadio {
	width: 70px;
}
.remark {
	width: 95px;
	text-align: right;
	position: relative;
	right: 28px;
}
/deep/ .el-textarea {
	width: 50% !important;
}
/deep/ .el-radio__inner {
	border: 1px solid #e2e3e8;
}

/deep/ .el-radio__label {
	padding-left: 0;
}
</style>
